"use strict";
var Observable_1 = require("../../Observable");
var dematerialize_1 = require("../../operator/dematerialize");
Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
//# sourceMappingURL=dematerialize.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/dematerialize.js
 ** module id = 282
 ** module chunks = 1
 **/